import { render, staticRenderFns } from "./install-banner.vue?vue&type=template&id=28a7fb05"
import script from "./install-banner.vue?vue&type=script&lang=ts"
export * from "./install-banner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28a7fb05')) {
      api.createRecord('28a7fb05', component.options)
    } else {
      api.reload('28a7fb05', component.options)
    }
    module.hot.accept("./install-banner.vue?vue&type=template&id=28a7fb05", function () {
      api.rerender('28a7fb05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layout/install-banner.vue"
export default component.exports